
import * as LIB from '../lib/common';
import styles from '../styles/SubHeader.module.css';

const SubHeader = ({ data, isExternal }) => {
    const jumpPage = (path) => {
        let url = LIB.getBasepath(path);
        window.open(url, '_self');
    }

    if (data) {
        if (Array.isArray(data)) {
            //content page
            return (
                <div className={styles.fullWidth4Content}>
                    <div className="viewport">
                        <div className={styles.holder}>
                            <a href='/web'><div className={styles.link}>首頁</div></a>
                            <div className={styles.separator}></div>
                            <div onClick={() => { jumpPage(data[1]) }} className={styles.link}>{data[0]}</div>
                            <div className={styles.separator}></div>
                            <div className={styles.txt}>{data[2]}</div>
                        </div>
                    </div>
                </div>
            );
        } else {
            //listing page
            return (
                <div className={[styles.fullWidth]}>
                    <div className="viewport">
                        <div className={styles.holder}>
                            <a href='/web'><div className={styles.link}>首頁</div></a>
                            <div className={styles.separator}></div>
                            <div className={styles.txt}>{data}</div>
                        </div>
                    </div>
                </div>
            );
        }
    } else if (isExternal === true) {
        //for external page only
        return (
            <div className={styles.fullWidth}>
                <div className="viewport">
                    <div className={styles.holder}>
                        <a href='/web'><div className={styles.link}>首頁</div></a>
                        <div className={styles.separator}></div>
                        <div id='subHeader' className={`${styles.txt} ${styles.external}`}>文章</div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (<></>);
    }

}

export default SubHeader;